import styled from 'styled-components';

export const PaginationContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
